import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';
import DriverStatus from 'components/orders/DriverStatus/DriverStatus';

export default styled(DriverStatus)`
  &.status {
    display: flex;
    justify-content: space-between;
    &:first-child {
      .prev-step {
        background-color: transparent;
      }
      .next-step {
        background-color: transparent;
      }
    }

    &:last-of-type {
      .step-data-wrapper {
        border: none;
        padding: ${gridSizes('M')} 0;
      }
      .next-step {
        background-color: transparent;
      }
    }

    &.cancelled {
      .current-step {
        background-color: var(--red-cherry-text);
      }
      .state {
        background-color: var(--red-cherry-text);
      }
      .driver-state {
        color: var(--red-cherry-text);
      }
      .step-cancel-icon {
        margin-right: 0.8rem;
        margin-bottom: 0.4rem;

        svg {
          fill: var(--red-cherry-text);
          transform: rotate(45deg);
        }
      }
    }

    .step-data-wrapper {
      line-height: 1.2;
      flex-grow: 1;
      position: relative;
      border-bottom: 1px solid var(--grey-mouse);
      padding: ${gridSizes('M')} 0 32px;
      ${media.lessThan('small')`
        font-size: 14px;
        padding: ${gridSizes('L')} 0;
        line-height: 1.4;
      `}
      ${media.lessThan('extraSmall')`
        padding: 20px 0;
      `}

      .step-title-wrapper {
        display: flex;

        .driver-state {
          margin: 0;
          font-weight: ${weights('medium')};
          font-size: 18px;
          margin-bottom: 6px;
          ${media.lessThan('small')`
            font-size: ${gridSizes('M')};
          `}
        }
      }
    }
  }
`;
